// 正则判断匹配
export const pattern = {
  // 账户名
  accountName: /^[a-zA-Z0-9\u4e00-\u9fa5·▪•▫]{1,32}$/,

  // 角色名 & 卡类型名称 & 补贴卡类型
  role: /^[a-zA-Z0-9\u4e00-\u9fa5]{1,20}$/,

  // 密码
  password: /^[0-9A-Za-z_+-/*%]{8,20}$/,

  // 邮箱
  email: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,

  // 手机
  phone: /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/,

  // 学工号
  code: /^[a-zA-Z0-9]{1,32}$/,

  // 身份证
  IDCard: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,

  // 其他证件
  card: /^[a-zA-Z0-9]{1,20}$/,

  // 学校代码
  school: /^[0-9]{5}$/,

  rate: /^[0-9]{0,3}$/,
  // 导航栏名称 & 显示内容 & 学校名称
  nav: /^[a-zA-Z0-9\u4e00-\u9fa5]{1,10}$/,

  // 链接地址
  url: /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/,

  // 补贴发放金额
  subsidy: /^\d{1,5}(\.\d{1,2})?$/,

  abd123: /^[a-zA-Z0-9]*$/,

  // 字母，数字，下划线
  basic: /^[a-zA-Z0-9_]*$/,

  // 字母，数字，下划线和中文
  basicAndCN: /^[a-zA-Z0-9_\u4e00-\u9fa5]*$/
}

export function isIdCardCode (code) {
  var city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  }
  var pass = true

  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/i.test(code)) {
    pass = false
  } else if (!city[code.substr(0, 2)]) {
    // pass = false
  } else {
    // // 18位身份证需要验证最后一位校验位
    // if (code.length === 18) {
    //   code = code.split('')
    //   // ∑(ai×Wi)(mod 11)
    //   // 加权因子
    //   const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    //   // 校验位
    //   const parity = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
    //   var sum = 0
    //   var ai = 0
    //   var wi = 0
    //   for (var i = 0; i < 17; i++) {
    //     ai = code[i]
    //     wi = factor[i]
    //     sum += ai * wi
    //   }
    //   if (parity[sum % 11] !== code[17]) {
    //     pass = false
    //   }
    // }
  }
  return pass
}



// WEBPACK FOOTER //
// ./src/util/regular.js